import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { ToolName } from '@textbook-drawer';
import { Observable } from 'rxjs';

@Component({
  selector: 'txtb-drawer-figures-tool',
  templateUrl: './drawer-figures-tool.component.html',
  styleUrls: ['./drawer-figures-tool.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DrawerFiguresToolComponent {
  @Input() activeColor: string | null | undefined;
  @Input() disabledColor: string | null | undefined;
  @Input() isOffline!: boolean;
  @Input() isZoomed = false;
  @Input() pickedTool$!: Observable<ToolName | undefined>;
  @Output() toolName = new EventEmitter<ToolName>();
  @Output() active = new EventEmitter<boolean>();

  tooltip = false;
  toolNames = ToolName;

  constructor(private elementRef: ElementRef) {}

  setTooltip(open: boolean): void {
    this.tooltip = open;
    this.active.emit(open);
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    if (this.tooltip && !this.elementRef.nativeElement.contains(event.target)) {
      this.setTooltip(false);
    }
  }

  sendTool(tool: ToolName): void {
    this.toolName.emit(tool);
    this.setTooltip(false);
  }
}
